/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Button, Icon, Title } from '@gerdau/hefesto';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import Table from '../../../../../../components/Table';
import { ERoutes } from '../../../../../../routes';
import {
  IFabricationMockupProject,
  IPavement
} from '../../../../../../store/ducks/fabrication-mockups/types';
import { sendTagging } from '../../../../../../store/ducks/tagging/actions';
import { getTaggingInformationScreen } from '../../../../../../utils/Tagging';
import { EProjectsMockupsRoutes } from '../../../../projectsMockup.routes';
import DownloadProjectColumn from '../../../Projects/ProjectsTable/ViewOptionsButton/DownloadProjectColumn';
import { Container, PavementProjectsHeader, StructureSpan } from './styles';
interface IPavementProjectsTableDataSource {
  key: number;
  projectName: string;
  structures: string[];
  creationDate: string;
  revision: string;
  action: IFabricationMockupProject;
}

interface IPavementProjectsTableProps {
  pavement: IPavement;
  contractNumber: string;
}

const PavementProjects: React.FC<IPavementProjectsTableProps> = ({
  contractNumber
}) => {
  const history = useHistory();
  const location = useLocation();
  const pavement = location.state as IPavement;

  const [pavementProjectsData, setPavementProjectsData] = useState<
    IPavementProjectsTableDataSource[]
  >([]);

  const dispatch = useDispatch();

  const { pathname } = location;
  const { screenName = '' } = getTaggingInformationScreen(pathname, true);

  useEffect(() => {
    dispatch(
      sendTagging({
        page: document.location.pathname,
        screenName,
        event: 'page_view'
      })
    );
  }, []);

  const getColumns = () => {
    const columns = [
      {
        title: 'Nome do projeto',
        dataIndex: 'projectName',
        sorter: (
          a: IPavementProjectsTableDataSource,
          b: IPavementProjectsTableDataSource
        ) => a.projectName.localeCompare(b.projectName),
        render: (text: string) => <>{text ? text : ' - '}</>
      },
      {
        title: 'Estrutura',
        dataIndex: 'structures',
        sorter: (
          a: IPavementProjectsTableDataSource,
          b: IPavementProjectsTableDataSource
        ) => a.structures.toString().localeCompare(b.structures.toString()),
        render: (structures: string[]) => (
          <>
            {structures.length > 0
              ? structures.map((structure, idx) => (
                  <StructureSpan key={idx}>{structure}</StructureSpan>
                ))
              : ' - '}
          </>
        )
      },
      {
        title: 'Revisão',
        dataIndex: 'revision',
        sorter: (
          a: IPavementProjectsTableDataSource,
          b: IPavementProjectsTableDataSource
        ) => a.revision.localeCompare(b.revision),
        render: (revision: string) => <>{revision ? revision : ' - '}</>
      },
      {
        title: 'Data de criação',
        dataIndex: 'creationDate',
        sorter: (
          a: IPavementProjectsTableDataSource,
          b: IPavementProjectsTableDataSource
        ) =>
          moment(a.creationDate).toDate().getTime() -
          moment(b.creationDate).toDate().getTime(),
        sortDirections: ['descend' as const],
        render: (creationDate: string) => (
          <>
            {creationDate ? moment(creationDate).format('DD/MM/YYYY') : ' - '}
          </>
        )
      },
      {
        title: 'Opções',
        dataIndex: 'action',
        render: (project: IFabricationMockupProject) => (
          <>
            <DownloadProjectColumn
              contractNumber={contractNumber}
              projectId={project.id}
              fileName={project.fileName}
            />
          </>
        )
      }
    ];

    return columns;
  };

  useEffect(() => {
    const data: IPavementProjectsTableDataSource[] = pavement.projects!.map(
      (project, idx) => ({
        key: idx,
        projectName: project.fileName,
        structures: project.structures.map((s) => s.name),
        creationDate: project.creationDate,
        revision: project.revision || ' - ',
        action: project
      })
    );

    setPavementProjectsData(data);
  }, [`${pavement.projects}`]);

  const goBackMockupView = () => {
    history.push(
      `${ERoutes.PROJECT_MOCKUP}${EProjectsMockupsRoutes.MOCKUP_VIEW}`
    );
  };

  return (
    <>
      <PavementProjectsHeader>
        <Button
          name="goBackButton"
          onClick={goBackMockupView}
          icon={<Icon option="ArrowLeft" />}
          variant="tertiary"
        >
          Voltar
        </Button>
        <Title level={1}>{`${pavement.name} - Projetos`}</Title>
        <span>
          Consulte aqui os dados sobre os projetos relacionados a este pavimento
        </span>
      </PavementProjectsHeader>
      <Container>
        <Table
          columns={getColumns()}
          data={pavementProjectsData}
          hasPagination
        />
      </Container>
    </>
  );
};

export default PavementProjects;
